import React, { useState } from 'react';
import './WhatsAppButton.css'; // Import CSS for animations
import { FaWhatsapp } from 'react-icons/fa'; 
import { GiCancel } from "react-icons/gi";

const WhatsAppPopup = () => {
  const phoneNumber = '+919620072626';  
  const [isOpen, setIsOpen] = useState(false);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  const handleClick = () => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    // WhatsApp URL for mobile or desktop
    const url = isMobile 
      ? `whatsapp://send?phone=${phoneNumber}` 
      : `https://web.whatsapp.com/send?phone=${phoneNumber}`;

    // Open WhatsApp in a new tab or window
    window.open(url, '_blank');
  };

  return (
    <div className="whatsapp-container">
      <div className='whatsapp-text'>Chat With Us</div>
      <button className="whatsapp-button" onClick={handleClick}>
        <div className="glow-effect"></div>
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          alt="WhatsApp"
        />
      </button>
    </div>
  );
};

export default WhatsAppPopup;
